import { useContext, useEffect, useState } from "react";
import { Instituicao } from "../../model/Instituicao";
import Campo from "../Campo";
import styles from "./styles.module.css";
import { cepMask, numberMask, phoneMask } from "../../controllers/Masks";
import { useMask } from "@react-input/mask";
import putInstituicao from "../../services/putInstituicao";
import { UserContext } from "../../context/UserContext";
import listarCidades from "../../services/listarCidades";
import CampoSelect from "../Campo/CampoSelect";
import VerificaForm from "../../controllers/VerificaForm";

type Props = {
  instituicaoObj: Instituicao;
  setInstituicao: React.Dispatch<React.SetStateAction<Instituicao | undefined>>;
  closeModal: Function;
};

const EditInstituicao = ({
  instituicaoObj,
  setInstituicao,
  closeModal,
}: Props) => {
  const [emailInstituicao, setEmail] = useState(instituicaoObj.email);
  const [telefoneInstituicao, setTelefone] = useState(instituicaoObj.telefone);
  const [cepEndereco, setCep] = useState(instituicaoObj.endereco.cep);
  const [estadoEndereco, setEstado] = useState(instituicaoObj.endereco.estado);
  const [cidadeEndereco, setCidade] = useState(instituicaoObj.endereco.cidade);
  const [bairroEndereco, setBairro] = useState(instituicaoObj.endereco.bairro);
  const [ruaEndereco, setRua] = useState(instituicaoObj.endereco.rua);
  const [numeroEndereco, setNumero] = useState(instituicaoObj.endereco.numero);
  const [listaCidades, setListaCidades] = useState(["", "Aquidauana"]);
  const [complementoEndereco, setComplemento] = useState(
    instituicaoObj.endereco.complemento || ""
  );
  useEffect(() => {
    const atualizarListaCidades = async () => {
      try {
        const response = await listarCidades(estadoEndereco);
        const cidades = response.map((c: any) => {
          return c.nome;
        });

        setListaCidades(cidades);
        if (estadoEndereco === "MS") {
          setCidade("Aquidauana");
        } else {
          setCidade(listaCidades[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };
    atualizarListaCidades();
  }, [estadoEndereco]);

  const { token } = useContext(UserContext);

  const salvarDados = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const editarInstituicao = async () => {
      try {
        await putInstituicao(
          token,
          instituicaoObj.cnpj,
          instituicaoObj.nome,
          emailInstituicao || instituicaoObj.email,
          telefoneInstituicao || instituicaoObj.telefone,
          cepEndereco || instituicaoObj.endereco.cep,
          estadoEndereco || instituicaoObj.endereco.estado,
          cidadeEndereco || instituicaoObj.endereco.cidade,
          bairroEndereco || instituicaoObj.endereco.bairro,
          ruaEndereco || instituicaoObj.endereco.rua,
          numeroEndereco || instituicaoObj.endereco.numero,
          complementoEndereco
        );
        setInstituicao({
          nome: instituicaoObj.nome,
          cnpj: instituicaoObj.cnpj,
          email: emailInstituicao || instituicaoObj.email,
          telefone: telefoneInstituicao || instituicaoObj.telefone,
          endereco: {
            cep: cepEndereco || instituicaoObj.endereco.cep,
            estado: estadoEndereco || instituicaoObj.endereco.estado,
            cidade: cidadeEndereco || instituicaoObj.endereco.cidade,
            bairro: bairroEndereco || instituicaoObj.endereco.bairro,
            rua: ruaEndereco || instituicaoObj.endereco.rua,
            numero: numeroEndereco || instituicaoObj.endereco.numero,
            complemento: complementoEndereco,
          },
        });
      } catch (err) {}
    };
    if (VerificaForm(e.currentTarget.form)) {
      editarInstituicao();
      closeModal();
    }
  };

  return (
    <form className={styles.formModal} onSubmit={salvarDados}>
      <h2>Editar dados da Instituição</h2>
      <div className={styles.camposDados}>
        <hr />
        <div className={styles.gridCampos}>
          <span className={styles.tuplaDado}>
            <strong>Nome da Instituição:</strong> {instituicaoObj.nome}
          </span>
          <span className={styles.tuplaDado}>
            <strong>CNPJ:</strong> {instituicaoObj.cnpj}
          </span>
        </div>
        <hr />
        <div className={styles.gridCampos}>
          <Campo
            title="Email"
            type="text"
            placeholder="email_do_membro@email.com"
            required
            maxLength={64}
            value={emailInstituicao}
            setter={setEmail}
          ></Campo>
          <Campo
            title="Telefone"
            type="text"
            required
            placeholder="(00)00000-0000"
            value={telefoneInstituicao}
            setter={setTelefone}
            mask={useMask(phoneMask)}
          ></Campo>
        </div>
        <hr className={styles.separador} />
        <h3 className={styles.subTitulo}>Endereço</h3>
        <div className={styles.gridCampos}>
          <Campo
            title="CEP"
            type="text"
            required
            minLength={9}
            placeholder="00000-000"
            value={cepEndereco}
            setter={setCep}
            mask={useMask(cepMask)}
          ></Campo>
          <CampoSelect title="Estado" setter={setEstado} value={estadoEndereco}>
            <option value="AC">Acre (AC)</option>
            <option value="AL">Alagoas (AL)</option>
            <option value="AP">Amapá (AP)</option>
            <option value="AM">Amazonas (AM)</option>
            <option value="BA">Bahia (BA)</option>
            <option value="CE">Ceará (CE)</option>
            <option value="DF">Distrito Federal (DF)</option>
            <option value="ES">Espírito Santo (ES)</option>
            <option value="GO">Goiás (GO)</option>
            <option value="MA">Maranhão (MA)</option>
            <option value="MT">Mato Grosso (MT)</option>
            <option value="MS">Mato Grosso do Sul (MS)</option>
            <option value="MG">Minas Gerais (MG)</option>
            <option value="PA">Pará (PA)</option>
            <option value="PB">Paraíba (PB)</option>
            <option value="PR">Paraná (PR)</option>
            <option value="PE">Pernambuco (PE)</option>
            <option value="PI">Piauí (PI)</option>
            <option value="RJ">Rio de Janeiro (RJ)</option>
            <option value="RN">Rio Grande do Norte (RN)</option>
            <option value="RS">Rio Grande do Sul (RS)</option>
            <option value="RO">Rondônia (RO)</option>
            <option value="RR">Roraima (RR)</option>
            <option value="SC">Santa Catarina (SC)</option>
            <option value="SP">São Paulo (SP)</option>
            <option value="SE">Sergipe (SE)</option>
            <option value="TO">Tocantins (TO)</option>
          </CampoSelect>
          <CampoSelect title="Cidade" setter={setCidade} value={cidadeEndereco}>
            {listaCidades &&
              listaCidades.map((cidade, index) => (
                <option value={cidade} key={index}>
                  {cidade}
                </option>
              ))}
          </CampoSelect>
          <Campo
            title="Bairro"
            type="text"
            placeholder="Bairro"
            required
            maxLength={64}
            value={bairroEndereco}
            setter={setBairro}
          ></Campo>
          <Campo
            title="Rua"
            type="text"
            required
            placeholder="Rua"
            maxLength={64}
            value={ruaEndereco}
            setter={setRua}
          ></Campo>
          <Campo
            title="Numero"
            type="text"
            placeholder="Numero"
            required
            value={numeroEndereco}
            setter={setNumero}
            mask={useMask(numberMask)}
          ></Campo>
          <Campo
            title="Complemento"
            type="text"
            placeholder="Complemento"
            maxLength={64}
            value={complementoEndereco}
            setter={setComplemento}
          ></Campo>
        </div>
        <hr />
      </div>
      <input type="submit" className={styles.editBtn} value="+ Editar Dados" />
    </form>
  );
};

export default EditInstituicao;
